import React, { useState, useReducer, useEffect } from 'react';
import {
  VirtualTableState,
  SortingState,
  DataTypeProvider,
  FilteringState,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableColumnResizing,
  TableFilterRow,
} from '@devexpress/dx-react-grid-material-ui';

import utils from '../utils'
import AuthService from '../services/auth-service';
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';
import Badge from '@mui/material/Badge';
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";

import ServiceUnlockCodeListTableProps, { 
  DateTypeProvider, 
  UnlockerUsernameFormatter, 
  TimeLimitFormatter, 
  RowNumTypeProvider, 
} from './ServiceUnlockCodeListTableProps'

import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';

import { Autocomplete, Stack, Paper, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material"
import LinearProgress from '@mui/material/LinearProgress';
import Slider, { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import notify from 'devextreme/ui/notify';

import _COUNTRIES from '../services/countries_states_cities'

// ************************************************************
// ************************************************************
// ************************************************************

function ValueLabelComponent(props) {
  const { children, value } = props;
  return (
    <Tooltip enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}

function NewUnlockCodeFormDialog(props) {
  
  const [firstName, setFirstName] = React.useState("")
  const [lastName, setLastName] = React.useState("")
  const [companyName, setCompanyName] = React.useState("")
  const [companyAddress, setCompanyAddress] = React.useState("")
  const [companyCountry, setCompanyCountry] = React.useState("")
  const [phone, setPhone] = React.useState("")
  const [note, setNote] = React.useState("")
  const [baseCode, setBaseCode] = React.useState("")
  const [mode, setMode] = React.useState("")
  const [timeLimit, setTimeLimit] = React.useState(0)
  
  const [is_plus_max_time_limit, set_is_plus_max_time_limit] = React.useState(false)
  const [is_omegas_time_limit, set_is_omegas_time_limit] = React.useState(false)

  const notifySomething = (message, type="success") => {
    notify({
      message: message,
      position: {
        my: 'center top',
        at: 'center top',
      },
    }, type, 3000)
  }
  const handleClose = () => {
    props.onClickClose()
    
    setFirstName("")
    setLastName("")
    setCompanyName("")
    setCompanyAddress("")
    setCompanyCountry("")
    setPhone("")
    setNote("")
    setBaseCode("")
    setMode("")
    setTimeLimit(0)

    set_is_omegas_time_limit(false)
    set_is_plus_max_time_limit(false)
  }
  const handleSubmit = () => {
    var userData = {
      first_name: firstName,
      last_name: lastName,
      company_name: companyName,
      company_address: companyAddress,
      company_country: companyCountry,
      phone: phone,
      note: note,
      base_code: baseCode,
      mode: mode,
      time_limit: timeLimit,
    }
    
    if (userData.mode === undefined) {      
      notifySomething("Mode not defined!", "error")
      return
    } 
    if (userData.base_code === undefined) {      
      notifySomething("Base code not defined!", "error")
      return
    }
    
    userData.mode = userData.mode.trim()
    userData.base_code = userData.base_code.trim().toUpperCase()

    switch (userData.mode) {
      default:
        notifySomething("Mode not valid!", "error")
        return
      case "standard":
        if (userData.base_code.length !== 8) {
          notifySomething("Base code length not valid!", "error")
          return
        }
        break;
      case "LF":
      case "RE":
      case "UZ":
        if (userData.base_code.length === 8) {
          // ok
        } else if (userData.base_code.length === 11) {          
          // ok, tolgo l'inizio
          userData.base_code = userData.base_code.slice(3)
          console.log(userData.base_code)
        } else {
          notifySomething("Base code length not valid!", "error")
          return
        }
        break;
      case "omegas":
        if (userData.base_code.length !== 10) {
          notifySomething("Base code length not valid!", "error")
          return
        }
        break;
    }

    console.log(userData)
    props.onClickSubmit(userData)
    
    setFirstName("")
    setLastName("")
    setCompanyName("")
    setCompanyAddress("")
    setCompanyCountry("")
    setPhone("")
    setNote("")
    setBaseCode("")
    setMode("")
    setTimeLimit(0)

    set_is_omegas_time_limit(false)
    set_is_plus_max_time_limit(false)
  }

  // **********************************************************
  // **********************************************************
  // **********************************************************

  const handleFirstNameChange = (e) => { setFirstName(e.target.value); }  
  const handleLastNameChange = (e) => { setLastName(e.target.value); }  
  const handleCompanyNameChange = (e) => { setCompanyName(e.target.value); }  
  const handleCompanyAddressChange = (e) => { setCompanyAddress(e.target.value); }  
  const handleCompanyCountryChange = (event, value) => { setCompanyCountry(value.name); }
  const handlePhoneChange = (e) => { setPhone(e.target.value); }  
  const handleNoteChange = (e) => { setNote(e.target.value); }  
  const handleBaseCodeChange = (e) => { setBaseCode(e.target.value); }    
  const handleModeChange = (e) => {
    console.log(e.target.value)
    if (e.target.value === "omegas") {
      set_is_omegas_time_limit(true)
      set_is_plus_max_time_limit(false)
      setTimeLimit(30)
    } else {
      set_is_omegas_time_limit(false)
      set_is_plus_max_time_limit(true)
      setTimeLimit(3)
    }
    setMode(e.target.value)
  }
  const handleTimeLimitPlusMaxChange = (e) => { setTimeLimit(e.target.value); }
  const handleTimeLimitOmegasChange = (e) => { setTimeLimit(e.target.value); }
  
  // **********************************************************
  // **********************************************************
  // **********************************************************

  var view_en = {
    mode_standard: false,
    mode_LF: false,
    mode_RE: false,
    mode_UZ: false,
    mode_omegas: false,

    cancel_button: true,
    build_button: true,

    show_spin: false,
  }  
  
  if ((props.accesso_keygen & 0x01) !== 0) {
    view_en.mode_standard = true
  }
  if ((props.accesso_keygen & 0x02) !== 0) {
    view_en.mode_LF = true
  }
  if ((props.accesso_keygen & 0x04) !== 0) {
    view_en.mode_RE = true
  }
  if ((props.accesso_keygen & 0x08) !== 0) {
    view_en.mode_UZ = true
  }
  if ((props.accesso_keygen & 0x10) !== 0) {
    view_en.mode_omegas = true
  }

  if (props.spin) {
    view_en.cancel_button = false
    view_en.build_button = false
    view_en.show_spin = true
  }
    
  // **********************************************************
  // **********************************************************
  // **********************************************************
  
  return (    
    <div>      
      <Dialog 
        maxWidth='sm'
        fullWidth={true}
        open={props.open} 
        //onClose={handleClose}
      >
        <DialogTitle>GENERATE NEW UNLOCK CODE</DialogTitle>
        <DialogContent>
          <Stack 
            spacing={3}            
          >
              <TextField
                value={firstName} 
                margin="dense"
                required
                id="first_name"
                label="First name"
                onChange={handleFirstNameChange}
                type="text"
                fullWidth
                variant="standard"
                disabled={view_en.show_spin}
                />
              <TextField
                value={lastName}
                margin="dense"
                required
                id="last_name"
                label="Last name"
                onChange={handleLastNameChange}
                type="text"
                fullWidth
                variant="standard"
                disabled={view_en.show_spin}
                />
              <TextField
                value={companyName}
                margin="dense"
                required
                id="company_name"
                label="Company name"
                onChange={handleCompanyNameChange}
                type="text"
                fullWidth
                variant="standard"
                disabled={view_en.show_spin}
                />
              <TextField
                value={companyAddress}
                margin="dense"
                required
                id="company_address"
                label="Company address"
                onChange={handleCompanyAddressChange}
                type="text"
                fullWidth
                variant="standard"
                disabled={view_en.show_spin}
                />
              <Autocomplete
                id="company_country"
                options={_COUNTRIES}
                autoHighlight
                getOptionLabel={(option) => option.name}
                onChange={handleCompanyCountryChange}
                renderOption={(props, option) => (
                  <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                    {option.name}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    id="company_country"
                    margin="dense"
                    required
                    variant="standard"
                    label="Company country"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'new-password', // disable autocomplete and autofill
                    }}
                  />
                )}
                />
              <TextField
                value={phone}
                margin="dense"
                required
                id="phone"
                label="Phone"
                onChange={handlePhoneChange}
                type="text"
                fullWidth
                variant="standard"
                disabled={view_en.show_spin}
                />
              <TextField
                value={note}
                margin="dense"
                id="note"
                label="Notes"
                multiline
                maxRows={4}
                onChange={handleNoteChange}
                type="text"
                fullWidth
                variant="standard"
                disabled={view_en.show_spin}
                />
              <TextField
                value={baseCode}
                margin="dense"
                required
                id="base_code"
                label="Base code"
                onChange={handleBaseCodeChange}
                type="text"
                fullWidth
                variant="standard"
                disabled={view_en.show_spin}
                />
              
              <FormControl margin="dense" variant="standard" >
                <InputLabel id="demo-simple-select-standard-label">Mode</InputLabel>
                <Select
                  id="mode"
                  onChange={handleModeChange}
                  label="Mode"
                  disabled={view_en.show_spin}
                  >
                  {view_en.mode_standard && (<MenuItem value="standard">Plus Max Standard</MenuItem>)}
                  {view_en.mode_LF && (<MenuItem value="LF">Plus Max ISO</MenuItem>)}
                  {view_en.mode_RE && (<MenuItem value="RE">Plus Max RE</MenuItem>)}
                  {view_en.mode_UZ && (<MenuItem value="UZ">Plus Max UZ</MenuItem>)}
                  {view_en.mode_omegas && (<MenuItem value="omegas">Omegas</MenuItem>)}
                </Select>
              </FormControl>

              {is_plus_max_time_limit && (
                <FormControl margin="dense" variant="standard" >
                  <InputLabel id="demo-simple-select-standard-label">Time limit (months)</InputLabel>
                  <Select
                    id="mode"
                    onChange={handleTimeLimitPlusMaxChange}
                    label="Time limit (months)"
                    disabled={view_en.show_spin}
                    >
                    <MenuItem value="0"><em>no limit</em></MenuItem>
                    <MenuItem value="3">3</MenuItem>
                    <MenuItem value="6">6</MenuItem>
                    <MenuItem value="12">12</MenuItem>
                  </Select>
                </FormControl>
              )}

              {is_omegas_time_limit && (
                <>
                  <Box sx={{ m: 2 }} />
                  <Typography gutterBottom>Time limit (days)</Typography>
                  <Slider
                    min={1}
                    max={365}
                    valueLabelDisplay="auto"
                    components={{
                      ValueLabel: ValueLabelComponent,
                    }}
                    aria-label="Time limit (days)"
                    defaultValue={timeLimit}
                    onChange={handleTimeLimitOmegasChange}
                  />
                </>              
              )}

          </Stack>
        </DialogContent>
        <DialogActions>
          <Button disabled={!view_en.cancel_button} onClick={handleClose}>Cancel</Button>
          <Button disabled={!view_en.build_button} onClick={handleSubmit}>Submit</Button>
        </DialogActions>
        {view_en.show_spin && <LinearProgress />}
      </Dialog>
    </div>
  );
}

// ************************************************************
// ************************************************************
// ************************************************************

const VIRTUAL_PAGE_SIZE = 50;
const getRowId = row => row.id;

// ************************************************************
// ************************************************************
// ************************************************************

export const ServiceUnlockCodeListComponentWrapper = (props) => {
  const { unlocker_id } = useParams()
  const navigate = useNavigate()
  return <ServiceUnlockCodeList 
    unlocker_id={unlocker_id} 
    navigate={navigate} 
    {...props} />
}

class ServiceUnlockCodeList extends React.Component {
  constructor(props) {    
    super(props)    
    this.table_props = new ServiceUnlockCodeListTableProps()
    this.state = {
      dialog_open: false,
      dialog_spin: false,
      table_total_row_count_ready: false,
      tableRows: [],
      tableSkip: 0,
      requestedTableSkip: 0,
      requestedTableTake: 0,
      tableTotalRowCount: VIRTUAL_PAGE_SIZE * 2,
      tableLoading: false,
      tableColumns: this.table_props.getTableColumns(),
      tableColumnExtensions: this.table_props.getTableColumnExtensions(),
      tableSortingStateColumnExtensions: this.table_props.getTableSortingStateColumnExtensions(),
      tableFilteringStateColumnExtensions: this.table_props.getTableFilteringStateColumnExtensions(),
      tableColumnWidths: this.table_props.getTableColumnWidths(),
      tableFilters: [],
      tableSorting: [{
        columnName: "created_at",
        direction: "desc",
      }],      
    }
  }
  
  async getTableRows(requestedTableSkip, take) {
    console.log("getTableRows")
    this.setState({ 
      requestedTableSkip: requestedTableSkip,
      requestedTableTake: take,
      tableLoading: true 
    })    
    AuthService.getServiceUnlockCodeList(requestedTableSkip, take, this.state.tableSorting[0], this.state.tableFilters, 0).then(data => {
      var i = requestedTableSkip + 1
      data.rows = data.rows.map(row => {
        row.row_num = i++
        return row
      })
      if (data.is_valid) {
        this.setState({
          tableSkip: data.skip, 
          tableRows: data.rows,
          tableLoading: false,
        })
      } else {
        //console.log(data.message)
        this.setState({ tableLoading: false })
      }
    }).catch(e => {
      //console.log(e)
      this.setState({ tableLoading: false })
    })
  }
  setTableSorting(value) {
    //console.log(value)
    this.setState({
      tableSorting: value
    })
  }
  async setTableFilters(value) {
    //console.log("setTableFilters", value)
    this.setState({ 
      tableFilters: value
    })    
    var data = await AuthService.getServiceUnlockCodeCount(value, 0)
    if (data.is_valid) {
      console.log("tableTotalRowCount", data.value)
      this.setState({
        tableTotalRowCount: data.value,
        table_total_row_count_ready: true,
      })
    }
  }
  setTableColumnWidths(value) {
    console.log(value)
    this.setState({
      tableColumnWidths: value
    })
  }
  async componentDidMount() {
    console.log("unlocker_id", this.props.unlocker_id) 
    var tableFilters = []
    if (this.props.unlocker_id !== undefined) {
      var data = await AuthService.getServiceUserDetails(this.props.unlocker_id)
      if (data.is_valid) {
        console.log("unlocker_username contains " + data.user.username)
        tableFilters.push({
          columnName: "unlocker_username",
          value: data.user.username,
          operation: "contains",
        })
      }
    }
    await this.setTableFilters(tableFilters)
  }

  handle_fab_click() {
    this.setState({ dialog_open: true })
  }
  notifySomething(message, type="success") {
    notify({
      message: message,
      position: {
        my: 'center top',
        at: 'center top',
      },
    }, type, 3000)
  }
  handleNewUnlockCodeFormDialogClose() { this.setState({ dialog_open: false }) }
  handleNewUnlockCodeFormDialogSubmit(e) {
    console.log(e)
    this.setState({ dialog_spin: true })
    AuthService.getUnlockCode(e).then(data => {
      if (data.is_valid) {
        // aggiorno la lista
        this.getTableRows(
          this.state.requestedTableSkip,
          this.state.requestedTableTake
        )
      } else {
        console.log(data.message)
        this.notifySomething(data.message, "error")
      }
      this.setState({ dialog_open: false, dialog_spin: false })
    }).catch(e => {
      console.log(e)
      this.notifySomething(e, "error")
      this.setState({ dialog_open: false, dialog_spin: false })            
    })
  }

  render() {     
    if (!this.props.authStatus.completed) return <LoadingSpinner />
    if (this.props.authStatus.user === null) return <UserAuthRequired notlogged />        

    if (this.props.authStatus.user.is_admin) {
      // ok
    } else if (this.props.authStatus.user.is_reseller) {
      // ok
    } else if (this.props.authStatus.user.accesso_keygen > 0) {
      // ok      
    } else {
      return <UserAuthRequired notallowed />
    }

    // aspettiamo che ci sia questa info prima di caricare il resto, altrimenti non mi aggiorna il filtro dei reseller
    if (!this.state.table_total_row_count_ready) return <LoadingSpinner />

    // ***

    var height = "calc(100vh - " + this.props.navbarHeight + ")"
    return (
      <Paper>

        <NewUnlockCodeFormDialog 
          open={this.state.dialog_open}
          spin={this.state.dialog_spin}
          accesso_keygen={(this.props.authStatus.user) ? this.props.authStatus.user.accesso_keygen : 0}
          onClickClose={this.handleNewUnlockCodeFormDialogClose.bind(this)} 
          onClickSubmit={this.handleNewUnlockCodeFormDialogSubmit.bind(this)}
        />
        
        <Grid 
          rows={this.state.tableRows}
          columns={this.state.tableColumns}
          getRowId={getRowId}
          >
          <RowNumTypeProvider 
            for={[ "row_num" ]} 
            availableFilterOperations={[
              'equal',
            ]}
            />
          <DataTypeProvider  
            for={[ 
              "unlocker_username"
            ]}
            formatterComponent={props => <UnlockerUsernameFormatter {...{ ...props, user: this.props.authStatus.user }} />}
            />  
          <DataTypeProvider  
            for={[ 
              "time_limit"
            ]}
            formatterComponent={props => <TimeLimitFormatter {...{ ...props, user: this.props.authStatus.user }} />}
            />  
          <DateTypeProvider for={[
            "created_at",
          ]} />
          <SortingState
            sorting={this.state.tableSorting}
            onSortingChange={this.setTableSorting.bind(this)}
            columnExtensions={this.state.tableSortingStateColumnExtensions}
            />
          <VirtualTableState 
            loading={this.state.tableLoading}
            totalRowCount={this.state.tableTotalRowCount} 
            pageSize={VIRTUAL_PAGE_SIZE}
            skip={this.state.tableSkip}
            getRows={this.getTableRows.bind(this)}
            />
          <FilteringState
            filters={this.state.tableFilters}
            onFiltersChange={this.setTableFilters.bind(this)}
            columnExtensions={this.state.tableFilteringStateColumnExtensions}
            />
          <VirtualTable 
            height={height}
            columnExtensions={this.state.tableColumnExtensions} 
            />
          <TableColumnResizing
            columnWidths={this.state.tableColumnWidths}
            onColumnWidthsChange={this.setTableColumnWidths.bind(this)}
            />
          <TableHeaderRow 
            showSortingControls
            />
          <TableFilterRow 
            showFilterSelector
            />
        </Grid>

        <Fab 
          sx={{
            position: "fixed",
            bottom: (theme) => theme.spacing(3),
            right: (theme) => theme.spacing(5),            
          }}
          onClick={() => this.handle_fab_click()}
          variant="extended"
          color="primary" 
          aria-label="add" 
        >
          <AddIcon sx={{ mr: 1 }} />
          ADD NEW
        </Fab>

      </Paper>
    )
  }
}
